import clsx from 'clsx';
import React from 'react';

import {
  TRANSACTION_TAB_INDEX,
  useFileEntryViewer,
} from '@/src/components/project/Inbox2/components/EntryPanel/FileEntryViewer/store/fileEntryViewer.store';

import { useTreatments } from '../../../../store/treatments.store';
import { FormTypeOption } from '../../../../types/treatment';
import { CheckPaymentFormOption } from '../../CheckPaymentForm/CheckPaymentForm';
import FormGroupContainer from '../../Form/FormGroupContainer/FormGroupContainer';
import { PaidBillFormOption } from '../../PaidBillForm/PaidBillForm';
import { UnpaidBillFormOption } from '../../UnpaidBillForm/UnpaidBillForm';
import FieldWrapper from '../FieldWrapper/FieldWrapper';
import SelectField, { Option, renderWithTypeOptions } from '../SelectField/SelectField';

const TypeField = () => {
  const { setForm, form: currentForm } = useTreatments();
  const { setActiveTab } = useFileEntryViewer();

  const FORM_TYPES = {
    Bill: UnpaidBillFormOption,
    Expense: PaidBillFormOption,
    Check: CheckPaymentFormOption,
  };

  const formOptions = Object.keys(FORM_TYPES).map((formKey) => {
    const form = FORM_TYPES[formKey];
    return {
      value: formKey,
      label: form && form.optionName ? form.optionName : '',
    };
  });

  const selected = formOptions.find((formOption) => formOption.label === currentForm.optionName);

  const handleClick = (form: FormTypeOption) => {
    setForm(form);
    setActiveTab(TRANSACTION_TAB_INDEX);
  };

  return (
    <FormGroupContainer className={clsx('tw-max-w-[180px] tw-w-full', 'tw-mr-[15px]')}>
      <FieldWrapper
        label={'Type'}
        required={true}
        labelWidthClasses={clsx('tw-min-w-[35px] tw-max-w-[35px]')}
        labelClassName={clsx('tw-text-cfo-grey-600')}
        containerClassName={clsx('tw-max-w-[180px] tw-w-full', 'tw-mr-[15px]')}
      >
        <SelectField
          isSearchable={true}
          renderOption={renderWithTypeOptions}
          selected={selected}
          options={formOptions}
          onChange={(selectedOption: Option) => {
            handleClick(FORM_TYPES[selectedOption.value]);
          }}
        />
      </FieldWrapper>
    </FormGroupContainer>
  );
};

export default TypeField;
